import React from "react";
import { Link } from "react-router-dom";
const AdminDashboard = () => {
  return (
    <>
      <section className="dashboard">
        <h2>Admin Dashboard</h2>
        <div className="left">
          <nav>
            <ul>
              <li>
                <Link to="/admin/add-product">Add Product</Link>
              </li>
              <li>
                <Link to="/admin/products">All Products</Link>
              </li>
            </ul>
          </nav>
        </div>
        <div className="right">
          <Container fluid>
            <Row>
              <Col lg={12} md={12} sm={12} xs={12}>
              </Col>
            </Row>
          </Container>
        </div>

      </section>
    </>
  );
}

export default AdminDashboard;